import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

export const Content1 = styled(Typography)(`
    font-weight:500;
    font-size:14px;
    padding-bottom:10px;
`)

export const Content2 = styled(Typography)(({ theme }) => `
    font-weight:300;
    font-size:14px;
    padding-bottom:10px;
    border-bottom: 1px ${theme.components.GridList.styleOverrides.borderColor} solid;
    margin-bottom:10px;
    & a {
        text-decoration: underline;
        color:${theme.components.MuiParagraph.styleOverrides.color};
    }
`)

export const Content3 = styled('div')(({ theme }) => `
    font-weight:300;
    font-size:14px;
    padding-bottom:10px;

    & .MuiInputBase-root:before {
        display:none;
    }

    & textarea {
        color:${theme.components.MuiParagraph.styleOverrides.color} !important;
        -webkit-text-fill-color:${theme.components.MuiParagraph.styleOverrides.color} !important;
        -moz-text-fill-color:${theme.components.MuiParagraph.styleOverrides.color} !important;
    }
`)

export const MediaWrapper = styled(Box)(`
    width: 266px;
    height: 255px;
`)
